export const airPriceWatchOptOutQuery = `
  mutation priceWatchUnsubscribe($watchIds: [String!]!, $requestId: String, $unsubscribeAll: Boolean) {
    priceWatchUnsubscribe(
      watchIds: $watchIds
      requestId: $requestId
      unsubscribeAll: $unsubscribeAll
    ) {
      prefMgmtStatus
      status
      statusCode
      statusMessage
    }
  }
`
